module.exports = __webpack_public_path__ + "assets/img/ABOUT HUNDSUN.1f7d8ef7.png";